
function main() {
    const elements = Array.from(document.querySelectorAll('.element'));

    if (!elements) return

    // Loop through elements and on hero bind it's chevron to scroll to the next element
    elements.forEach((element, i) => {
        if (element.classList.contains('elements__hero')) {
            const chevron = element.querySelector('.hero__chevron');
            const next = elements[i+1];

            if (!next) return;

            chevron.addEventListener('click', () => {
                next.scrollIntoView({ behavior: 'smooth', block: 'start' });
            })
        }
    })
}

main()
